import React from 'react';
const  TableBlock = (props) => {
  return(	
  <>	
  	{/*  <!-- SECTION CONTENT START --> */}
	<div className="section-full p-t80 p-b50">
		<div className="container">
			{/* <!-- TABLE RESPONSIVE --> */}
			<div className="section-content m-b80">
				<div className="p-b30">
					<h3 className="text-uppercase">MONTHLY FEE STRUCTURE SESSION-2025-26 Pre-School to 5th</h3>
					<div className="wt-separator-outer">
						<div className="wt-separator style-icon">
							<i className="fa fa-leaf text-black"></i>
							<span className="separator-left site-bg-primary"></span>
							<span className="separator-right site-bg-primary"></span>
						</div>
					</div>
				</div>
				<div id="no-more-tables">
					<table className="col-md-12 table-bordered table-striped table-condensed cf wt-responsive-table">
						<thead className="cf">
							<tr>
								<th>Fee Type</th>
								<th>Amount</th>
								<th className="numeric">Details</th>								
							</tr>
						</thead>
						<tbody>
							<tr>
								<td data-title="Admission Fee">Admission Fee</td>
								<td data-title="Tuition Fee">₹200/-</td>
								<td data-title="Details" className="numeric">At the time of admission</td>
								
								
							</tr>
							<tr>
								<td data-title="Tuition Fee">Tuition Fee</td>
								<td data-title="Amount">₹3920/- per month</td>
								<td data-title="Details" className="numeric">Per child</td>
								
							</tr>
							<tr>
								<td data-title="Development Charges">Development Charges</td>
								<td data-title="Amount">₹580/- per month</td>
								<td data-title="Details" className="numeric">Per child</td>
								
							</tr>
							<tr>
								<td data-title="Smart Class Charges">Smart Class Charges</td>
								<td data-title="Amount">₹150/- per month</td>
								<td data-title="Details" className="numeric">Per child</td>
								
							</tr>
								
						</tbody>
					</table>
				</div>
			</div>
			
			
			
			{/* <!-- TABLE RESPONSIVE --> */}
			<div className="section-content m-b80">
				<div className="p-b30">
					<h3 className="text-uppercase">MONTHLY FEE STRUCTURE SESSION-2025-26 VI to VIII</h3>
					<div className="wt-separator-outer">
						<div className="wt-separator style-icon">
							<i className="fa fa-leaf text-black"></i>
							<span className="separator-left site-bg-primary"></span>
							<span className="separator-right site-bg-primary"></span>
						</div>
					</div>
				</div>
				<div id="no-more-tables">
					<table className="col-md-12 table-bordered table-striped table-condensed cf wt-responsive-table">
						<thead className="cf">
							<tr>
								<th>Fee Type</th>
								<th>Amount</th>
								<th className="numeric">Details</th>								
							</tr>
						</thead>
						<tbody>
							<tr>
								<td data-title="Admission Fee">Admission Fee</td>
								<td data-title="Tuition Fee">₹200/-</td>
								<td data-title="Details" className="numeric">At the time of admission</td>
								
								
							</tr>
							<tr>
								<td data-title="Tuition Fee">Tuition Fee</td>
								<td data-title="Amount">₹4110/- per month</td>
								<td data-title="Details" className="numeric">Per child</td>
								
							</tr>
							<tr>
								<td data-title="Development Charges">Development Charges</td>
								<td data-title="Amount">₹610/- per month</td>
								<td data-title="Details" className="numeric">Per child</td>
								
							</tr>
							<tr>
								<td data-title="Smart Class Charges">Smart Class Charges</td>
								<td data-title="Amount">₹150/- per month</td>
								<td data-title="Details" className="numeric">Per child</td>
								
							</tr>
								
						</tbody>
					</table>
				</div>
			</div>
			
			
		</div>
	</div>
	{/* <!-- SECTION CONTENT END --> */}	
  </>
  )
}
 export default TableBlock;